import React, { FC, PropsWithChildren } from 'react'
import s from './FormControl.module.scss'
import { useFormControlContext } from './_FormControlContext'
interface Props {
  htmlFor?: string
}
type NativeAttrs = Omit<React.HTMLAttributes<HTMLLabelElement>, keyof Props>

export type FormControlLabelProps = Props & NativeAttrs

const FormControlLabel: FC<PropsWithChildren<FormControlLabelProps>> = ({
  children,
  htmlFor,
  ...props
}) => {
  const { disabled, id: formControlId, required } = useFormControlContext()
  return (
    <label className={s.label} htmlFor={htmlFor || formControlId} {...props}>
      {required ? (
        <span className={s.requiredWrapper}>
          {children} <span className={s.required}>*</span>
        </span>
      ) : (
        children
      )}
    </label>
  )
}

FormControlLabel.displayName = 'FormControlLabel'
export default FormControlLabel
